module.exports = __webpack_public_path__ + "static/img/rank-top.0eb83fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-home/rank-top.png
// module id = eahO
// module chunks = 52